import { useDelFbAccMutation } from "../../services";

const useDeleteFbFanPage = () => {
    const [deleteFbAcc, { isLoading: deleteLoading, isSuccess: deleteSuccess }] = useDelFbAccMutation();

    const handleDelete = async (fbBotId: string) => {
        await deleteFbAcc({
            id: fbBotId,
        });
    };

    return { handleDelete, deleteLoading, deleteSuccess };
};
export default useDeleteFbFanPage;
